import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryOverview() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">多元题材，覆盖你的每一种观看偏好</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-white rounded-lg border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-800 whitespace-nowrap mb-1">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.articleCount} 篇内容
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}